import { render, staticRenderFns } from "./header1.vue?vue&type=template&id=029effcb&scoped=true&"
import script from "./header1.vue?vue&type=script&lang=js&"
export * from "./header1.vue?vue&type=script&lang=js&"
import style0 from "./header1.vue?vue&type=style&index=0&id=029effcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029effcb",
  null
  
)

export default component.exports